import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-api-checkout-page',
  templateUrl: './api-checkout-page.component.html',
  styleUrl: './api-checkout-page.component.scss',
})
export class ApiCheckoutPageComponent {
  invoiceId?: string;
  tenantId?: string;

  constructor(
    private authService: AuthService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    const params = this.route.snapshot.params;
    this.invoiceId = params['id'];
    this.tenantId = this.authService.currentUser?.tenant_id;
  }
}
